import { inject, observer } from 'mobx-react'
import React from 'react'
import { v4 as uuidv4 } from 'uuid'
import ModalWrapper from '../Inputs/ModalWrapper'

@inject('workAreaStore', 'store') @observer
class PermissionsModal extends React.Component {

  createNewDesign(){
    const id = uuidv4()
    const { auth } = this.props
    if(!auth){
      localStorage.setItem('designId', id)
      if(localStorage.getItem('design')){
        localStorage.removeItem('design')
        localStorage.removeItem('designId')
      }
    }
    window.location.href = window.location.origin + '/design-editor/' + id
  }

  render(){
    const { invalidPermissionsModal } = this.props.workAreaStore
    const isLive = process.env.REACT_APP_NODE_ENV !== 'development'
    if(!invalidPermissionsModal){
      return
    }
    if(invalidPermissionsModal){
      return (
        <ModalWrapper
          close={() => { return false }}
          modalClass='permissions-modal'
        >
          <div className='permissions-modal__wrapper row no-gutters'>
            <div className='col-xs-12 col-md-6 upgrade-modal__text' style={{
              height: '300px'
            }}>
              <h2 className='permissions-modal__heading'>
                No permissions to open this design
              </h2>
              <p className='permissions-modal__subheading'>
                You don't have access to this design. Please request access from the owner or create a new design.
              </p>
              <button 
                onClick={() => this.createNewDesign()}
                className='btn btn-primary w-100 permissions-modal__cta-btn'
              >
                Create new design
              </button>
            </div>
            <div className='col-xs-0 col-md-6 permissions-modal__image-wrapper'>
              <img className='permissions-modal__image' src={isLive ? `/design-editor/modal-1.png` : `/modal-1.png`} />
            </div>
          </div>
        </ModalWrapper>
      )
    }
  }

}

export default PermissionsModal